import React from "react";
import { Switch, Route } from "react-router-dom";

import ItemsPage from "./ItemsPage";
import ItemPage from "./ItemPage";

const ItemsRouter = () => (
  <Switch>
    <Route path="/inventory/items/:id">
      <ItemPage />
    </Route>
    <Route path="/inventory/items">
      <ItemsPage />
    </Route>
  </Switch>
);

export default ItemsRouter;
